import { render, staticRenderFns } from "./AcoesLead.vue?vue&type=template&id=b57fe3d0"
import script from "./AcoesLead.vue?vue&type=script&lang=ts"
export * from "./AcoesLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports